import {
  MainTabsV2,
  ModalConfirmV2,
  ModalSizeVariants,
} from '@labrav/react-components'
import { Dispatch, SetStateAction, useMemo, useState } from 'react'
import { useStyles } from './AddEditCompetitors.styles'
import awsImage from '../../../common/images/awsCloud.png'
import gcpImage from '../../../common/images/gcpMarketPlace.png'
import azureImage from '../../../common/images/azureCloud.png'
import { Chip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChess, faTrash, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { ListingUrlInput } from './ListingUrlInput'
import { useDispatch, useSelector } from '../../../store'
import { deleteCompetitorData } from '../../../modules/mpsSeo/action'
import { CompetitorType } from '../../../modules/mpsSeo/reducer'
import { SEO_CLOUD_MARKETPLACE, useSeoAccountId } from '../seoCloud'

export const AddEditCompetitors = ({
  openCompetitor,
  setOpenCompetitor,
}: {
  openCompetitor: boolean
  setOpenCompetitor: Dispatch<SetStateAction<boolean>>
}) => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const accountId = useSeoAccountId()
  const selectedCloud = SEO_CLOUD_MARKETPLACE

  const competitors = useSelector<CompetitorType[]>(
    state => state.marketplaceSeo[selectedCloud].competitors
  )

  const competitorsList = useMemo(() => {
    return competitors?.filter(item => !item?.self)
  }, [competitors])

  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [competitorToDelete, setCompetitorToDelete] =
    useState<CompetitorType | null>(null)

  const handleCloudTabChange = (index: number) => {
    setActiveTabIndex(index)
  }

  const cloudTabs = [
    {
      label: 'AWS',
      key: 'aws',
      icon: <img src={awsImage} alt="aws-image" className={classes.awsImage} />,
      renderElement: () => null,
    },
    {
      label: 'GCP',
      key: 'gcp',
      icon: (
        <img src={gcpImage} alt="gcp-image" className={classes.cloudImage} />
      ),
      renderElement: () => null,
      disabled: true,
      tootTipText: 'Coming soon',
    },
    {
      label: 'Microsoft',
      key: 'azure',
      icon: (
        <img
          src={azureImage}
          alt="azure-image"
          className={classes.cloudImage}
        />
      ),
      renderElement: () => null,
      disabled: true,
      tootTipText: 'Coming soon',
    },
  ]

  const handleDeleteChip = (item: CompetitorType) => {
    if (!item?._id) {
      return
    }
    setCompetitorToDelete(item)
  }

  const handleConfirmDelete = () => {
    if (competitorToDelete?._id && accountId) {
      dispatch(
        deleteCompetitorData(
          accountId,
          competitorToDelete._id,
          competitorToDelete?.name,
          selectedCloud
        )
      )
    }
    setCompetitorToDelete(null)
  }

  const handleCancelDelete = () => {
    setCompetitorToDelete(null)
  }

  const competitorChips = (
    <div className={classes.chipList}>
      {[...competitorsList].map(item => (
        <Chip
          key={item._id ?? item.name}
          className={classes.chip}
          label={item?.name}
          variant="outlined"
          onDelete={() => handleDeleteChip(item)}
          deleteIcon={
            <FontAwesomeIcon icon={faXmark} width="18px" height="18px" />
          }
        />
      ))}
    </div>
  )

  const inputBox = <ListingUrlInput />

  const content = [
    {
      content: (
        <div className={classes.cloudContent}>
          {inputBox}
          {competitorChips}
        </div>
      ),
    },
  ]
  return (
    <>
      <ModalConfirmV2
        title={'Manage Competitor'}
        icon={<FontAwesomeIcon style={{ height: '16px' }} icon={faChess} />}
        description={
          <div className={classes.description}>
            Select your competitors on cloud marketplace for tracking
          </div>
        }
        content={
          <>
            <div
              className={classes.mainTabContainer}
              data-testid="manage-competitor-section"
            >
              <MainTabsV2
                activeTabIndex={activeTabIndex}
                onChange={handleCloudTabChange}
                tabs={cloudTabs}
              />
              {content[activeTabIndex].content}
            </div>
          </>
        }
        open={openCompetitor}
        hideAcceptButton
        hideCancelButton
        onAccept={() => void 0}
        onDecline={() => setOpenCompetitor(false)}
        variant={ModalSizeVariants.xLarge}
        maxWidth={'900px'}
      />
      <ModalConfirmV2
        title={'Remove competitor?'}
        description={
          <div className={classes.competitorDescription}>
            This removes the competitor and all their tracking history. Add them
            back to start tracking fresh with new data only.
          </div>
        }
        open={!!competitorToDelete}
        titleAcceptButton={'Remove'}
        onAccept={handleConfirmDelete}
        onDecline={handleCancelDelete}
        variant={ModalSizeVariants.small}
        icon={
          <FontAwesomeIcon
            icon={faTrash}
            style={{ width: '20px', height: '16px' }}
          />
        }
        hideCancelIcon={false}
        hideCancelButton={false}
      />
    </>
  )
}
